export default "__VITE_ASSET__Cu2iWVDr__"